module.exports = __webpack_public_path__ + "static/media/microsoft_dynamics_thumbnail.615bba9a.png";